export const environment = {
  production: false,
  version: '1.0',
  disableAuthGuard: true, // Desactivar guards en desarrollo
  environment: 'QA',
  BASE_URL: 'https://l46s0358we.execute-api.us-west-2.amazonaws.com/prod',
  AI_URL: 'https://api.qa.sipadmi.com/extractor',
  AI_API_KEY: 'L8DrM6jVew9XHN3YUPsadfAuKFBtR7pE5WgcCvhZ4b',
  // URLs del Orquestador - QA
  orchestratorApiUrl: 'https://orchestrator-qa.example.com/api',
  orchestratorWebSocketUrl: 'wss://orchestrator-qa.example.com',
  websocketUrl: 'wss://orchestrator-qa.example.com/ws', // URL específica para WebSocket de detalle de pago
  cognito: {
    userPoolWebClientId: '4e91j45j5mvkdkkkelp9gq64f0',
    userPoolId: 'us-west-2_32QqHJhe0',
  },
};
